import React from 'react';
import Login from '../components/Login';

function Home() {
  return (
    <Login />
  );
}

export default Home;
